import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Acquisitions';
import CollectionPending from './components/Pendings'; //Acquisition/Pendings
import CollectionPawn from './components/Pawns';
import CollectionImport from './components/Imports';
import Object from './components/Acquisition'; //Take off S
import ObjectPending from './components/Pending'; //Acquisition/Pending

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, locations, states, scannedCode, reloadPage}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection
					locations={locations} states={states}
					scannedCode={scannedCode}
					reloadPage={reloadPage}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pawns`}>
				<CollectionPawn locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/imports`}>
				<CollectionImport locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pendings`}>
				<CollectionPending locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pendings/:id`}>
				<ObjectPending
					locations={locations} states={states}
					baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object
					locations={locations} states={states}
					scannedCode={scannedCode}
					baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
